import type { PublicApiKey } from '@/apilib';
import type { createCampaignsApi } from './campaignsApi';

export const CampaignsApiKey: PublicApiKey<typeof createCampaignsApi> = {
  name: 'CampaignsApi',
  public: true,
};
